import { useQuery } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  GetGroupSubscriptionParams,
  getGroupSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useGroupSubscription(params: GetGroupSubscriptionParams) {
  const { data, isLoading } = useQuery([GROUP_SUBSCRIPTION_KEY, params?.type], () =>
    getGroupSubscription(params)
  );
  return { data, isLoading };
}
